import { combineReducers, configureStore } from '@reduxjs/toolkit';
import User from './reducers/User/reducer';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore, createMigrate, createTransform } from 'redux-persist';
import { encryptData, decryptData } from './utils/crypto';

const encryptTransform = createTransform(
  (inboundState) => encryptData(inboundState), // Encrypt state before saving
  (outboundState) => decryptData(outboundState), // Decrypt state when loading
);

const persistConfig = {
  key: 'root',
  storage,
  version: 6,
  transforms: [encryptTransform],
  migrate: createMigrate({
    6: (state) => {
      return {
        ...state,
        user: {
          ...state.user,
          selectedTimeRange: null,
          orgId: null,
        },
      };
    },
  }),
};

const rootReducer = combineReducers({
  user: User,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
});

export const persistor = persistStore(store);
